module.exports = __webpack_public_path__ + "assets/hospitality.cbdb7c56.svg";